import { render, staticRenderFns } from "./TwPartialCardItem.vue?vue&type=template&id=a38fbc1c&scoped=true&"
import script from "./TwPartialCardItem.vue?vue&type=script&lang=js&"
export * from "./TwPartialCardItem.vue?vue&type=script&lang=js&"
import style0 from "./TwPartialCardItem.vue?vue&type=style&index=0&id=a38fbc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38fbc1c",
  null
  
)

export default component.exports